import { AddCandidatesComponent } from './add-candidates.component';
import { UploadResumesModule } from './uploadResumes/upload-resumes.module';
import { UploadSingleResumeComponent } from './uploadSingleResume/upload-single-resume.component';
export const AddCandidatesModule = angular
    .module('addCandidatesModule', [UploadResumesModule])
    .component('addCandidates', AddCandidatesComponent)
    .component(UploadSingleResumeComponent.selector, UploadSingleResumeComponent.component)
    .name;
//# sourceMappingURL=add-candidates.module.js.map